var SCM = SCM || {};

(function (SolrSearch, $, undefined) {

    // ----
    // private variables and functions
    // ----
    var bodyVar = $('body'),
        hfParentSiteName = $('#hfParentSiteName'),
        queryText = '';

    var baseSiteURL = $('#hfSiteURL');

    if (typeof baseSiteURL !== 'undefined' && baseSiteURL.val() !== '') {
        SCM.SearchResults.defaults.baseSiteUrl = baseSiteURL.val();
    }

    function reannounceSearchResults() {
        var $alerts = $('.sr-alert-noresults[role="alert"], .sr-statistics[role="alert"]');
        if ($alerts.length) {
            $alerts.removeAttr('role');
            setTimeout(function () { $alerts.attr('role', 'alert'); }, 100);
        }
    }

    // Used in both iconClickSearch() and keydownSearch()
    var testSearchInput = function (inputToTest) {
        if (hfParentSiteName.val() !== '') {
            doSolrSearch(inputToTest);
        } else {
            //search term should not be blank
            if ($.trim(inputToTest) === '' || inputToTest === null || inputToTest === 'Search') {
                alert('Please enter a term to search: ');
                return false;
            } else if (inputToTest) {
                doSolrSearch(inputToTest);
                return true;
            } else {
                alert('SCM.SolrSearch.testSearchInput() fail');
                return false;
            }
        }

    }; // END: testSearchInput()


    var testKeypress = function (e, inputToPass) {
        if (e.keyCode === 13) {
            e.preventDefault();
            testSearchInput(inputToPass);
        }
    }; // END: testKeypress()


    function doSolrSearch(inquiry) {
        queryText = encodeURIComponent(inquiry);

        var quickSearchUrl = $('.hfQuickSearchUrl').val();
        var searchUrl = '';
        if (quickSearchUrl) {
            searchUrl = quickSearchUrl.replace('{searchQuery}', queryText);
            window.location = searchUrl;
        } else {
            //STATS:instead of passing in all the Journal IDs, just pass allJournals=1 in the querystring            var journalIdParms = '&allJournals=1';
            searchUrl = 'search-results?page=1&q=' + queryText + '&SearchSourceType=1';

            var hfSiteURL = $('#hfSiteURL');
            if (hfSiteURL.length) {
                searchUrl = '//' + hfSiteURL.val() + '/' + searchUrl;
            }
            window.location.href = searchUrl;
        }


    } // END: doSolrSearch(inquiry, journalId)

    var openSaveSolrSearch = function (solrSearchSaveModel) {
        $(solrSearchSaveModel).closest('.reveal-modal').addClass('open');
        $('body').addClass('on-canvas'); // the grey BG
    };

    function initDateRangeToggle() {
        $('.date-range-input-radio').on('click', function () {
            if ($(this).attr('value') === 'single') {
                $('.date-input-to').addClass('hide');
                $('.date-label-from span').text('Search on this date');
            } else {
                $('.date-input-to').removeClass('hide');
                $('.date-label-from span').text('From');
            }
        });
    }

    var saveSolrSearchInfo = function (solrSearchSaveModel) {
        var txtSolrSearchName = $('.txtSolrSearchName');

        if ($.trim(txtSolrSearchName.val()) === '' || txtSolrSearchName.val() === null) {
            alert('Please enter a name');
            return false;
        }
        var ddlSearchAlertFrequency = $('#ddlSearchAlertFrequency');
        var redirectUrl = $('#hdnSearchSaveRedirectUrl');
        var currentUrl = window.location.href;
        var data = JSON.stringify({ searchName: txtSolrSearchName.val(), url: currentUrl, scheduleId: ddlSearchAlertFrequency.val(), redirectUrl: redirectUrl.val() });
        var ajaxUrl = '//' + SCM.SearchResults.defaults.baseSiteUrl + '/Solr/SaveSolrSearchInfo';

        $.ajax({
            url: ajaxUrl,
            type: 'POST',
            dataType: 'json',
            cache: false, // to defeat browser URL caching
            data: data,
            contentType: 'application/json; charset=utf-8',
            success: function (result) {
                if (result.RedirectUrl && result.RedirectUrl.length) {
                    window.location = result.RedirectUrl;
                } else {
                    alert(result.Html);
                    $(solrSearchSaveModel).closest('.reveal-modal').removeClass('open');
                    $('body').removeClass('on-canvas');
                }
            },
            error: function (xmlHttpRequest, textStatus, errorThrown) {
                if (window.console) {
                    var err = eval('(' + xmlHttpRequest.responseText + ')');
                    console.log('error: ' + err);
                    console.log('status: ' + textStatus);
                }
            }
        });
    };

    function buildSaveSearchUiEvent() {
        var lnkSaveSolrSearch = $('.lnkSaveSolrSearch'),
            solrSearchSaveModel = $('.solrSearchSaveModel'),
            btnSolrSearchSave = $('.btnSolrSearchSave'),
            txtSolrSearchName = $('.txtSolrSearchName');

        // save solr search. Unbind event before register click event to prevent multiple clicks.
        lnkSaveSolrSearch.off('click').on('click', function () {
            var isUserLoggedIn = $(this).data('userloggedin');
            if (isUserLoggedIn && isUserLoggedIn.toLowerCase() === 'false') {
                var redirectUrl = $('#hdnSearchSaveRedirectUrl');
                if (!redirectUrl || redirectUrl === '') {
                    redirectUrl = '/sign-in';
                }
                var currentUrl = window.location.href;
                window.location = redirectUrl.val() + '?returnUrl=' + encodeURIComponent(currentUrl + '#triggerSaveSearch=1');
            } else {
                openSaveSolrSearch(solrSearchSaveModel);
            }
        });
        btnSolrSearchSave.off('click').on('click', function () { saveSolrSearchInfo(solrSearchSaveModel); });
        txtSolrSearchName.off('keypress').on('keypress', function (e) {
            var code = e.keyCode || e.which;
            if (code === 13) {
                saveSolrSearchInfo(solrSearchSaveModel);
            }
        });
    }


    function restrictedImagesSearch() {
        $('div.sri-figure[restricted]').each(function () {
            $(this).off('contextmenu').on('contextmenu', function () { return false; });
        });
    }

    function toggleBoundingCoordMessage() {
        var search = location.search.substring(1);
        var boundPrm = SCM.Common.getQueryStringValue(search, 'exPrm_fq');
        if (!boundPrm || boundPrm.length < 1) {
            $('.sr-map-results-text').addClass('hide');
        }
    }

    function updateMapResultsButtons() {

        if (window.location.pathname.indexOf('map-results') > 0) {
            $('#btnViewResultsInSearch').removeClass('hide');
            $('#btnViewResultsInMapResults').addClass('hide');
        }

        // END - View Results in Search button click
    }

    //START - View Results in MapResults button click
    $('body').on('click', '#btnViewResultsInMapResults', function () {
        var search = location.search.substring(1);

        if (SCM.SearchResults.defaults.baseSiteUrl !== '') {
            location.href = '//' + baseSiteURL.val() + '/map-results?' + search;
        }
    });
    // END - View Results in MapResults button click

    //START - View Results in Search button click
    $('body').on('click', '#btnViewResultsInSearch', function () {
        var search = location.search.substring(1);
        var boundCoordSearch = SCM.Common.getQueryStringValue(search, 'boundCoordSearch');
        if (boundCoordSearch == undefined || boundCoordSearch.length < 1) {
            var boundPrm = SCM.Common.getQueryStringValue(search, 'exPrm_fq');
            if (boundPrm != undefined && boundPrm.length) {
                search = search.replace('&exPrm_fq=' + boundPrm, '');
            }
            var boundPt = SCM.Common.getQueryStringValue(search, 'exPrm_pt');
            if (boundPt != undefined && boundPt.length) {
                search = search.replace('&exPrm_pt=' + boundPt, '');
            }
        }
        if (SCM.SearchResults.defaults.baseSiteUrl !== '') {
            location.href = '//' + baseSiteURL.val() + '/search-results?' + search;
        }
    });


    //------------------TAXONOMY------------------------------
    //TaxonomyBrowse
    $('body').on('click', '.taxonomy-label', function () {
        var currentDataUrl = $('#TaxonomyCurrentDataUrl').val();
        currentDataUrl = decodeURIComponent(currentDataUrl);

        //check if this is the root node (for now, we're not executing any query for root node)
        var rootNodeSelectedId = $(this).attr('data-parentid');
        if (rootNodeSelectedId === '') {
            return;
        }

        //get root node
        var rootNodeId = $('.taxonomy-node').attr('data-id');
        //alert('ROOT NODE: ' + rootNodeId);

        //selected taxonomy node
        //var curTaxonomyNodeId = $(this).attr('data-id');
        var curTaxonomyNodeId = $(this).parent('.taxonomy-label-wrap').attr('data-id');
        //alert('TAX NODE: ' + curTaxonomyNodeId);
        //alert('Current Data Url: ' + currentDataUrl);

        //check if any taxonomy filters have been applied already.
        var taxQsPos = currentDataUrl.indexOf('tax');
        var taxQsPresent = taxQsPos === -1 ? false : true;

        if (!taxQsPresent) {
            //filter applied for the first time.
            currentDataUrl += '&tax=' + curTaxonomyNodeId;

        } else {
            //taxonomy filter applied previously
            var taxQueryTerm = currentDataUrl.substring(taxQsPos);
            if (taxQueryTerm !== null && taxQueryTerm !== '') {
                //check if taxonomy query was executed via Subject Dropdown, which is based on the rootNode.
                if (taxQueryTerm.indexOf('=' + rootNodeId) > -1) {
                    //remove the root node and just use the selected node to expedite the query execution
                    currentDataUrl = currentDataUrl.replace(taxQueryTerm, 'tax=' + curTaxonomyNodeId);
                }
                else if ($.inArray(curTaxonomyNodeId, decodeURIComponent(taxQueryTerm.slice(4)).split(',')) === -1) {
                    //taxonomy query was executed from the facet section and has not already been selected
                    var newQuery = 'tax=' + curTaxonomyNodeId;
                    currentDataUrl = currentDataUrl.replace(taxQueryTerm, newQuery);
                }
            }
        }

        SCM.SearchResults.doSolrSearch({ queryString: currentDataUrl, source: 'searchresults' });
    });

    function bindUiEvents() {
        var $micrositeSearchIcon = $('.microsite-search-icon'),
            $micrositeSearchTerm = $('.microsite-search-term'),
            $mobileMicrositeSearchIcon = $('.master-header').find('.mobile-microsite-search-icon'),
            $mobileMicrositeSearchTerm = $('.master-header').find('.mobile-microsite-search-term'),
            $toolbarSearchIcon = $('.toolbar-search').find('.microsite-search-icon'),
            $toolbarSearchTerm = $('.toolbar-search').find('.microsite-search-term'),
            $umbrellaSearchIcon = $('#UmbrellaSearchIcon'), // icon
            $umbrellaHomeSearchIcon = $('#UmbrellaHomeSearchIcon'), // home icon
            $umbrellaSearchTerm = $('#UmbrellaSearchTerm'), // term 
            $umbrellaHomeSearchTerm = $('#UmbrellaHomeSearchTerm'), // home term
            $articleKeywordSearchTerm = $('.kwd-part'), // article page keyword term
            $quickSearchUrl = $('.hfQuickSearchUrl'),
            $quickSearchSelectMobile = $('.navbar-search-filter-mobile'),
            $quickSearchSelectSite = $('.navbar-search-filter-site');
        // Searches performed when a search icon is clicked
        $umbrellaSearchIcon.on('click', function () { testSearchInput($umbrellaSearchTerm.val()); });
        $umbrellaHomeSearchIcon.on('click', function () { testSearchInput($umbrellaHomeSearchTerm.val()); });
        $micrositeSearchIcon.on('click', function () { testSearchInput($micrositeSearchTerm.val()); });
        $mobileMicrositeSearchIcon.on('click', function () { testSearchInput($mobileMicrositeSearchTerm.val()); });
        $toolbarSearchIcon.on('click', function () { testSearchInput($toolbarSearchTerm.val()); });

        $('.searchLi .icon-search').on('click', function () { testSearchInput($micrositeSearchTerm.val()); });
        $articleKeywordSearchTerm.on('click', function () { testSearchInput($(this).attr('data-keyword')); });

        // Searches performed when 'Enter' is pressed
        $umbrellaSearchTerm.on('keypress', function (e) { testKeypress(e, $umbrellaSearchTerm.val()); });
        $umbrellaHomeSearchTerm.on('keypress', function (e) { testKeypress(e, $umbrellaHomeSearchTerm.val()); });
        $micrositeSearchTerm.on('keypress', function (e) { testKeypress(e, $micrositeSearchTerm.val()); });
        $mobileMicrositeSearchTerm.on('keypress', function (e) { testKeypress(e, $mobileMicrositeSearchTerm.val()); });
        $toolbarSearchTerm.on('keypress', function (e) { testKeypress(e, $toolbarSearchTerm.val()); });

        $quickSearchSelectMobile.on('change',
            function (e) {
                sessionStorage.setItem('quickSearchUrlVal', $(this).val());
                $quickSearchUrl.val($(this).val());
                normalizeSelectedIndices($(this).prop('selectedIndex'));

            });

        $quickSearchSelectSite.on('change',
            function () {
                sessionStorage.setItem('quickSearchUrlVal', $(this).val());
                $quickSearchUrl.val($(this).val());
                normalizeSelectedIndices($(this).prop('selectedIndex'));
            });
        $('.master-main').on('click', '.js-show-book-abstract-link', function () {
            $(this).parent().parent().find('.js-abstract-response-placeholder').toggleClass('hide');
        });
    } // END: bindUiEvents

    function normalizeSelectedIndices(newIndex) {
        $('.navbar-search-filter-mobile, .navbar-search-filter-site').each(function (index, value) {
            $(this).prop('selectedIndex', newIndex);
        });
    }

    function bindViewAllImages() {
        //Expanding thumbnails when 'View All' is clicked
        $('.js-view-all-figures').off('click').on('click', function () { 
            $(this).closest('.js-figures').find('.js-figures-rows')
                .slideToggle()
                .find('img.lazy').trigger('appear');
        });
    }

    // ----
    // public methods and properties accessible by SCM.[module_name].[method_name]
    // ----
    SolrSearch.init = function () {
        bindUiEvents();
        bindViewAllImages();
        buildSaveSearchUiEvent();
        initDateRangeToggle();
        restrictedImagesSearch();
        toggleBoundingCoordMessage();

        // Mobile Search Filters
        $('main').on('click', '.collapsible-facet .sf-group-header', function () {
            //Search filters are only collapsible on mobile/table viewports
            if ($(window).outerWidth() < 1024) {
                var $this = $(this);
                var $facetHeaderIcon = $this.children('.sf-group-header-icon');

                $this.siblings('fieldset').children('.sf-facets, .sf-facet-list').slideToggle();
                $this.siblings('.taxonomy-node').slideToggle();
                $facetHeaderIcon.hasClass('icon-general_arrow-right') ? $facetHeaderIcon.removeClass('icon-general_arrow-right').addClass('icon-general_arrow-down') : $facetHeaderIcon.removeClass('icon-general_arrow-down').addClass('icon-general_arrow-right');
            }
        });

        // configure Query Builder on page load
        SCM.QueryBuilder.configure();

        if ($(SCM.SearchResults.defaults.updateTargetSelector).length > 0) {
            //we're on the search results page so all searches should call the search results search method
            SCM.QueryBuilder.defaults.runSearch = function (queryString) { SCM.SearchResults.doSolrSearch({ queryString: queryString, source: 'searchresults' }); };
        } else {

            //configure querybuilder for advance search
            $('.querybuilder-submit').attr('value', 'Search');
            $('.querybuilder-title').text('Modify your search');

            SCM.QueryBuilder.defaults.runSearch = function (redirectUrl) {
                var searchSiteUrl = $('#hfSiteURL').val();
                if (redirectUrl.indexOf('q=') === -1) {
                    redirectUrl = 'q=' + redirectUrl;
                }
                window.location = window.location.protocol + '//' + searchSiteUrl + '/search-results?' + redirectUrl;
            };
        }



        // give initial sort order selection a class of 'selected'
        $('.sort-dropdown-option:selected').addClass('selected');


        bodyVar.on('click', '.sriTopiclink', function (e) {
            queryText = $(this).text();
            var searchTerm = queryText.replace(',', ''); // if string ends with coma remove it.
            doSolrSearch(searchTerm);

            e.preventDefault();
        }); // END: $body.on('click', '.sriTopiclink', function (e) {})


        bodyVar.on('click', '#topicResultsWire', function (e) {
            var query = location.search;
            //journalId needs to be removed from query -- it's the last param
            query = query.substring(0, query.indexOf('&fd_JournalID'));
            window.location.href = 'solr/topicresults.aspx' + query;
        }); // END: $body.on('click', '#topicResultsWire', function (e) {})

        reannounceSearchResults();
    }; // END: SolrSearch.init()

    SolrSearch.ajaxComplete = function () {
        reannounceSearchResults();
        bindViewAllImages();
        buildSaveSearchUiEvent();
        initDateRangeToggle();
        restrictedImagesSearch();
        SCM.QueryBuilder.configure();
        updateMapResultsButtons();
        toggleBoundingCoordMessage();
        SCM.PageTitleHelper.SetDynamicPageTitle('#js-search-terms-page-title');
        if (window.location.pathname.includes('map-results')) {
            SCM.Toolbar.mobileToolbarAccordian();
            SCM.Toolbar.toolbarDropdowns();
        }       
    };

    SolrSearch.documentReady = function () {
        if (window.location.pathname.includes('map-results') && window.__sharethis__?.initialize) {
            __sharethis__.initialize();
        }
    };


    SCM.SearchResults.defaults.instanceName = 'Site_Theme_SearchResults';
    
    if ($('.pg_map-results').length) {
        SCM.SearchResults.defaults.updateTargetSelector = '#searchResultsPage'; // overwrite default value of '#divSearch'
    } else {
        SCM.SearchResults.defaults.updateTargetSelector = '.content-main_content'; // overwrite default value of '#divSearch'
    }

    SCM.SolrSearch.init();

})(SCM.SolrSearch = SCM.SolrSearch || {}, jQuery);

